import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { acknowledgeBestandsschutz, getBestandsschutz, type BestandsschutzState } from '../api/membership';
import { useAuth } from '../auth/AuthProvider';
import { Button, ResponsiveDialog } from '../components/ui';
import { useT } from '../i18n';
import { useStartupGate } from './StartupGateCoordinator';

export function BestandsschutzHost() {
  const auth = useAuth();
  const gate = useStartupGate();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { lang, t } = useT();
  const [offer, setOffer] = useState<BestandsschutzState | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (auth.status !== 'authed') {
      setOffer(null);
      return undefined;
    }
    void getBestandsschutz()
      .then((result) => { if (!cancelled && result.state === 'pending') setOffer(result); })
      .catch(() => undefined);
    return () => { cancelled = true; };
  }, [auth.status, auth.user?.userId]);

  if (!offer || gate !== 'none') return null;
  const parsedDate = offer.plusUntil ? new Date(offer.plusUntil) : null;
  const date = parsedDate && !Number.isNaN(parsedDate.getTime())
    ? new Intl.DateTimeFormat(lang, { dateStyle: 'long' }).format(parsedDate)
    : '';

  const act = async (action: 'seen' | 'claim') => {
    setBusy(true);
    try {
      await acknowledgeBestandsschutz('seen');
      setOffer(null);
      // Paket 75: GiftHost wartet auf diesen Zustand, bevor er seinen Hinweis zeigt.
      void queryClient.invalidateQueries({ queryKey: ['bestandsschutz'] });
      if (action === 'claim') navigate('/mitgliedschaft?tier=ultra&discount=bestand25');
    } finally {
      setBusy(false);
    }
  };

  return (
    <ResponsiveDialog
      open
      onClose={() => undefined}
      title={t('membership.bestandsschutz.title')}
      footer={(
        <>
          <Button variant="secondary" disabled={busy} onClick={() => void act('seen')}>{t('membership.bestandsschutz.continue')}</Button>
          <Button loading={busy} onClick={() => void act('claim')}>{t('membership.bestandsschutz.claim')}</Button>
        </>
      )}
    >
      <p>{t('membership.bestandsschutz.body', { date })}</p>
    </ResponsiveDialog>
  );
}
